import React, { useEffect, useState } from "react";
import clone from "lodash.clonedeep"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Button, FormGroup } from "react-bootstrap";
import ParticipantListItem from "./ParticipantListItem";

const ParticipantsList = (
    {
        group,
        onAddMember,
        onUpdateOrder,
        onEditMember,
        onDelete,
    }
) => {
    const [visiblelist, setVisibleList] = useState([]);

    useEffect(() => {
        setVisibleList(group.members || []);
    }, [group]);

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedParticipants = reorder(
            visiblelist,
            result.source.index,
            result.destination.index,
        );

        onUpdateOrder(reorderedParticipants);
    };

    async function handleEditMember(member) {
        onEditMember(member, group);
    }

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    return (
        <>
            <FormGroup>
                <Button onClick={onAddMember}>
                    Добавить участника
                </Button>
            </FormGroup>
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {
                                !!group.members?.length &&
                                group.members?.map((member, index) => (
                                    <Draggable
                                        key={member.id}
                                        draggableId={`${member.id || index}`}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={
                                                    provided.draggableProps.style
                                                }
                                            >
                                                <ParticipantListItem
                                                    member={member}
                                                    onEdit={handleEditMember}
                                                    onDelete={onDelete}
                                                >
                                                    {
                                                        (member.topicRu || member.topicEn) &&
                                                        <span>Тема: {member.topicRu || member.topicEn}</span>
                                                    }
                                                </ParticipantListItem>
                                            </div>
                                        )}
                                    </Draggable>
                                ))
                            }
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </>
    );
};

export default ParticipantsList;
